import { Badge } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import lodash from 'lodash';
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';

const { isNull } = lodash;

interface IProps {
  value: number;
}

enum AudioQuality {
  POOR,
  EXTREMELY_POOR,
}
const BADGE_MAP = {
  [AudioQuality.POOR]: {
    color: 'orange',
    label: 'Poor audio quality',
  },
  [AudioQuality.EXTREMELY_POOR]: {
    color: 'red',
    label: 'Extremely poor audio quality',
  },
};

export default function AudioQialityBadge({ value }: IProps) {
  const qualityAssessment = assessAudioQuality(value);

  if (isNull(qualityAssessment)) return null;

  const badgeValues = BADGE_MAP[qualityAssessment];

  return (
    <Badge size="sm" colorScheme={badgeValues.color}>
      <FontAwesomeIcon className="utility-icon" icon={faExclamationTriangle} />
      {badgeValues.label}
    </Badge>
  );
}

const assessAudioQuality = (score: number): AudioQuality | null => {
  if (score < 5) return AudioQuality.EXTREMELY_POOR;
  if (score >= 5 && score <= 6) return AudioQuality.POOR;

  return null;
};
